import { Typography } from 'design-system/src/components/Typography/Typography';
import { PDFDisplay } from './PDFDisplay';
import { useState } from 'react';
import styled from 'styled-components';
import { FormTopBar } from 'shared-utils/components/forms/FormTopBar';
import { NAVBAR_HEIGHT } from 'design-system/src/components/TopNavbar/TopNavbar';
import Button from 'design-system/src/components/Button/Button';
import DownloadTrayIcon from 'design-system/src/assets/icons/downloadTray.svg?react';
import { useFormFillerCompletedDocumentUrl } from './hooks';
import * as pdfjsLib from 'pdfjs-dist';

// PDF.js worker setup - use CDN to ensure correct version
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).href;

const Container = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  max-height: calc(100vh - ${NAVBAR_HEIGHT}px);
  display: flex;
  flex-direction: column;
`;

export function CompletedFormPage({
  token,
  formName,
  completedAt,
}: {
  token: string;
  formName: string;
  completedAt: string;
}) {
  const [pageCount, setPageCount] = useState(1);
  const getCompletedDocumentUrl = useFormFillerCompletedDocumentUrl();
  const documentUrl = getCompletedDocumentUrl(token, /* attachment */ false);
  const downloadHref = getCompletedDocumentUrl(token, /* attachment */ true);
  return (
    <>
      <FormTopBar
        leftContent={<FormInfo formName={formName} completedAt={completedAt} />}
        rightContent={
          <Button variant="primary" href={downloadHref}>
            <DownloadTrayIcon /> Download PDF
          </Button>
        }
      />
      <Container>
        <PDFDisplay
          basePdfUrl={documentUrl}
          renderOverlay={() => null}
          pageCount={pageCount}
          setPageCount={setPageCount}
          pdfjsLib={pdfjsLib}
        />
      </Container>
    </>
  );
}

function FormInfo({ formName, completedAt }: { formName: string; completedAt: string }) {
  const completedAtString = new Date(completedAt).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  return (
    <div>
      <Typography styledAs="bodyLargeSpaceGrotesk" weight={700}>
        {formName}
      </Typography>
      <Typography styledAs="bodySmallSpaceGrotesk" weight={400}>
        Completed on {completedAtString}
      </Typography>
    </div>
  );
}
